var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportSupportersColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#004D72",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3328 46.0005C20.759 46.0005 18.5601 45.0817 16.7358 43.2442C14.9116 41.4067 13.9995 39.1609 13.9995 36.5067C13.9995 34.2317 14.6641 32.2047 15.9934 30.4255C17.3227 28.6463 19.0621 27.5088 21.2116 27.013C21.9186 24.3297 23.3328 22.1567 25.454 20.4942C27.5752 18.8317 29.9792 18.0005 32.6661 18.0005C35.9752 18.0005 38.7823 19.189 41.0873 21.5661C43.3924 23.9432 44.5449 26.838 44.5449 30.2505C46.4964 30.4838 48.1156 31.3515 49.4025 32.8536C50.6894 34.3557 51.3328 36.113 51.3328 38.1255C51.3328 40.313 50.5904 42.1724 49.1055 43.7036C47.6207 45.2349 45.8176 46.0005 43.6964 46.0005H34.3631C33.4298 46.0005 32.6308 45.6578 31.9661 44.9724C31.3015 44.2869 30.9691 43.463 30.9691 42.5005V33.488L28.254 36.2005L25.8782 33.7505L32.6661 26.7505L39.454 33.7505L37.0782 36.2005L34.3631 33.488V42.5005H43.6964C44.8843 42.5005 45.8883 42.0776 46.7085 41.2317C47.5287 40.3859 47.9388 39.3505 47.9388 38.1255C47.9388 36.9005 47.5287 35.8651 46.7085 35.0192C45.8883 34.1734 44.8843 33.7505 43.6964 33.7505H41.151V30.2505C41.151 27.8297 40.3237 25.7661 38.6691 24.0599C37.0146 22.3536 35.0136 21.5005 32.6661 21.5005C30.3186 21.5005 28.3176 22.3536 26.6631 24.0599C25.0085 25.7661 24.1813 27.8297 24.1813 30.2505H23.3328C21.6924 30.2505 20.2924 30.8484 19.1328 32.0442C17.9732 33.2401 17.3934 34.6838 17.3934 36.3755C17.3934 38.0672 17.9732 39.5109 19.1328 40.7067C20.2924 41.9026 21.6924 42.5005 23.3328 42.5005H27.5752V46.0005H23.3328Z",
    fill: "#004D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportSupportersColor);
export default __webpack_public_path__ + "static/media/ImportSupportersColor.660d272381d8ec631253b0fd50f78e3f.svg";
export { ForwardRef as ReactComponent };